@if (isLocalContent && languageCodes && languageUrls) {
  <p kb-paragraph>
    @for (languageCode of languageCodes; track languageCode) {
      <a kb-link [kbRouterOrExternalLink]="languageUrls[languageCode]">
        <img class="flag" src="assets/flags/{{getCountryCodeFromLanguageCode(languageCode)}}.svg">
        <span class="text">{{ contentInYourLanguage(languageCode) }}</span>
      </a>
    }
  </p>
}
